import { DataWarning } from '../../types';
import { ChartData } from '../data/common';

export const getWarningsBelongingOnTopOfChart = (chartData: ChartData[], warnings: DataWarning[] = []) => {
  return warnings.filter(([, { kpis }]) => {
    const warningKpisHaveData =
      kpis.length === 0 || kpis.some(({ name }) => chartData.find(chart => chart.yColumn.name === name)?.hasData);
    return warningKpisHaveData;
  });
};

export const hasChartDataWithData = (chartData?: ChartData[]): boolean => {
  return !!chartData && chartData.some(sDataSet => sDataSet.hasData === true);
};
